import { render } from "./UserPulseStatsEventsItem.vue?vue&type=template&id=b687d140&scoped=true"
import script from "./UserPulseStatsEventsItem.vue?vue&type=script&lang=js"
export * from "./UserPulseStatsEventsItem.vue?vue&type=script&lang=js"

import "./UserPulseStatsEventsItem.vue?vue&type=style&index=0&id=b687d140&scoped=true&lang=css"

import exportComponent from "/builds/vrs/docker/web/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b687d140"]])

export default __exports__